import { combineReducers, type AnyAction, type Reducer } from "redux";
import { logout as authLogout } from "../store/authSlice";

import { authentication } from "./authentication.reducer";
import { users } from "./users.reducer";
import { alert } from "./alert.reducer";
import { loginDetails } from "./logindetails.reducer";
import authReducer from "../store/authSlice";
import roleReducer from "../store/roleSlice";
import permissionReducer from "../store/permissionSlice";
import featureAccessReducer from "../store/featureAccessSlice";
import casesClientSearchReducer from "../store/casesClientSearchSlice";
import clientDetailReducer from "../store/clientDetailSlice";
import globalAlertReducer from "../store/globalAlertSlice";
import dashboardReducer from "../store/dashboardSlice";
import { appApi } from "../store/api/appApi";
import reportsReducer from "../store/reportsSlice";
import myProfileReducer from "../store/myProfileSlice";
import categoriesReducer from "../store/categoriesSlice";
import casesReducer from "../store/casesSlice";
import caseDetailReducer from "../store/caseDetailSlice";
import userDetailReducer from "../store/userDetailSlice";
import chatReducer from "../store/chatSlice";

const appReducer = combineReducers({
  authentication,
  users,
  alert,
  loginDetails,
  auth: authReducer,
  role: roleReducer,
  permission: permissionReducer,
  featureAccess: featureAccessReducer,
  casesClientSearch: casesClientSearchReducer,
  clientDetail: clientDetailReducer,
  globalAlert: globalAlertReducer,
  dashboard: dashboardReducer,
  reports: reportsReducer,
  myProfile: myProfileReducer,
  categories: categoriesReducer,
  cases: casesReducer,
  caseDetail: caseDetailReducer,
  userDetail: userDetailReducer,
  chat: chatReducer,
  [appApi.reducerPath]: appApi.reducer,
});

export type AppReducerState = ReturnType<typeof appReducer>;

const rootReducer: Reducer<AppReducerState, AnyAction> = (state, action) => {
  if (action.type === authLogout.type) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
